export default "__VITE_ASSET__DGq1BcMU__"